import Styles from './Skeleton.styles';

import type { SkeletonProps } from './Skeleton.d';

export const Skeleton = ({ duration, height, width, ...props }: SkeletonProps) => (
  <Styles.Component {...props} css={{ width, height }}>
    <Styles.Skeleton duration={duration} />
  </Styles.Component>
);
